module.exports = __webpack_public_path__ + "img/mini-007.3c8ca125.jpg";